import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { MenuItem } from '../../types/Menu';
import { IconComponent } from '../icon/icon.component';
import { globalModules } from '../../utils/global-modules';
import { Router } from '@angular/router';
import { MenuItemComponent } from "./menu-item/menu-item.component";

@Component({
  selector: 'app-custom-sidebar-content',
  imports: [...globalModules, MenuItemComponent],
  standalone: true,
  templateUrl: './sidebar-content.component.html',
  styleUrl: './sidebar.component.css',
  styles: [
    `
    :host {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    `,


  ],
})
export class SidebarContentComponent implements OnChanges, OnInit {
  ngOnInit(): void {
    this.markExpandedMenus(this.menus)
  }
  activeOffcanvas = inject(NgbActiveOffcanvas);
  router = inject(Router);

  @Input() menus: MenuItem[] = [];
  hover = false

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['menus']) {
      this.markExpandedMenus(this.menus)
    }
  }
 
  navigate(path?: string) {
    if (path) {
      // Handle navigation logic
      this.activeOffcanvas.dismiss();
    }
  }
  toggleSubMenu(menu: MenuItem) {
    menu.expanded = !menu.expanded;
  }
  markExpandedMenus(menus: MenuItem[]): boolean {
    let foundActive = false;
    for (const menu of menus) {
      if (menu.items?.length) {
        const isChildActive = this.markExpandedMenus(menu.items);
        
        if (isChildActive) {
          menu.expanded = true;
          foundActive = true;
        }
      }
  
      if (menu.path && this.isActive(menu.path)) {
        foundActive = true;
      }
    }
  
    return foundActive;
  }

  isActive(path?: string) {
    if (!path) {
      return false;
    }
    return this.router.isActive(path, {
      paths: 'exact',
      queryParams: 'subset',
      fragment: 'ignored',
      matrixParams: 'subset',
    });
  }



}
